import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'; 
import {store} from './redux/store'; 
import { QueryClient, QueryClientProvider } from "react-query";
import './index.scss';
import App from './App';

// Create a QueryClient instance
const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(

    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
    </Provider>

);
